<template>
  <div class="popup-overlay">
    <div class="cert-wrap">
      <div class="print-btn" @click="printCertificate">인쇄</div>
      <div class="close-btn" @click="$emit('close')">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="#646464" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <div class="cert-container">
        <div class="cert-id">{{ mySeminarCertificate.certificateId }}</div>
        <div class="title">{{ mySeminarCertificate.title }}</div>
        <div class="name">성명 : {{ mySeminarCertificate.name }}</div>
        <div class="company-name">회사명 : {{ mySeminarCertificate.companyName }}</div>
        <div class="content">{{ mySeminarCertificate.content }}</div>
        <div class="date is-13r">{{ mySeminarCertificate.date }}</div>
        <div class="sign">{{ mySeminarCertificate.sign }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CertImg',
  props: {
    mySeminarCertificate: {
      type: Object,
      default: () => ({
        title: '',
        name: '',
        companyName: '',
        content: '',
        date: '',
        sign: ''
      })
    }
  },
  methods: {
    printCertificate() {
      window.print()
    }
  }
}
</script>
<style scoped lang="scss">
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.print-btn {
  position: absolute;
  left: 20px;
  top: 20px;
  font-size: 13px;
  padding: 6px 12px;
  background: #dbdbdb;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  font-weight: 700;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}
@media print {
  .print-btn {
    display: none !important;
  }
  .close-btn {
    display: none !important;
  }
}
.cert-wrap {
  background-image: url('https://s3.ap-northeast-2.amazonaws.com/cdn.insabank/seminar/certificate/cert-bg.jpg') !important;
  background-size: cover !important;
  height: 600px !important;
  width: 840px !important;
  position: relative !important;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
  .cert-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 350px;
    position: relative;
    margin: 0 auto;
    padding-top: 120px;
  }
  .cert-id {
    font-size: 10px;
    position: absolute;
    left: -130px;
    top: 80px;
  }

  .title {
    font-size: 34px;
    margin-bottom: 30px;
  }
  .name {
    margin-left: auto;
    font-size: 13px;
  }
  .company-name {
    margin-left: auto;
    font-size: 13px;
    margin-bottom: 24px;
  }
  .content {
    white-space: pre-line;
    font-size: 14px;
    text-align: center;
    margin-bottom: 30px;
  }
  .date {
    font-size: 13px;
    margin-bottom: 45px;
  }
  .sign {
    white-space: pre-line;
    text-align: center;
  }
}
</style>
